export const defaultData = () => {
    return {
        due_date: null,
        product_id: null,
        lot: null,
        quantity: null
    }
}
export default {
    loading: false,
    error: null,
    dataProductsWms: defaultData(),
    availabilityWmsProducts: [],
    params: {
        filter: "",
    },
    params_request: {
        product: null
    }
};



// WEBPACK FOOTER //
// ./src/modules/modal-list-product-wms/state.js